<!-- =========================================================================================
    File Name: Home.vue
    Description: Home Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <b-overlay
    :show="show"
    :variant="variant"
    :opacity="opacity"
    :blur="blur"
    rounded="lg"
    spinner-variant="primary"
    v-if="appointments.length"
  >
    <div class=" vx-col sm:w-full md:w-full lg:w-full xl:w-full client-portal" >
      <div :class="routes == 'Document' ? 'home-card p-5 vx-card':''" :style="'background-color:'+style.form_background_color">
        <h1 class="fw-bolder" v-if="routes == 'Document'" :style="textColor">
          {{ $t("ClientDesk") }} / {{ $t("Documents") }}
        </h1>
             <div class="w-full text-dark p-2" v-if="routes == 'Document'" >
               <hr>
               </div>    
        <div class="w-full">
          <div :class="routes == 'Document' ? 'card-size bg-e':''" class=" w-full xs:w-full sm:w-full padding-1r" :style="routes == 'Document' ? bgColor: '' ">
            <strong :style="textColor"  class="text-dark font-20">{{ $t("Documents") }} :</strong>
            <div class="w-full">
              <ul class="list-group">
                <li
                  v-for="(user, index) of appointments"
                  :key="index"
                  class="flex list-group-item br-20 mt-4"
                  :style="bgColor"
                >
                  <div class="zoom">
                    <auth-image v-if="user.type == 'image' && user.is_chat" :path="user.path"
                     style="height: 70px; width: 70px;" 
                     class="border-p15 border-primary shadow-md cursor-pointer block img-doc"/>

                    <img
                      v-else-if="!user.is_chat && !user.answer.includes('.pdf')"
                      :src="previewLinks[user.answer]"
                      key="onlineImg"
                      alt="user-img"
                      width="70"
                      height="70"
                      class="border-p15 border-primary shadow-md cursor-pointer block"
                    />
                    <iframe
                      v-else
                      class="border-p15 border-primary shadow-md cursor-pointer block img-doc "
                      :src="previewLinks[user.answer]"
                      width="70"
                      height="70"
                      :key="previewLinks[user.answer]" 
                    />
                  </div>

                  <div class="w-full p-2 ml-2">
                      <h6
                      class="fw-bolder text-dark font-18 white-space-sm mobile-hide"
                      :style="textColor"
                    >
                      {{ user.display_name }}
                    </h6>
                    <h6 :style="textColor" v-if="!user.is_chat"><strong>{{user.question}}</strong>: {{$t(user.answer_label)}}</h6>
                    <h6 :style="textColor" v-if="user.is_chat">{{$t("Sharedinchat")}}</h6>
                  </div>

                      <div class="w-full ml-2 center-item ">
                            <router-link
                                v-if="user.status == -1"
                        class="text-danger"
                        :to="`/user/update/${user.is_chat ? 1 : 0}/${user.answer_id}
                    `"
                      >
                    <b-button
                  
                      type="filled"
                      class=" border-15 font-14 text-danger btn-padding white-space-sm  fw-bolder noHover"
                      variant="outline-danger"
                    >
                  
                        {{ $t("Replace") }}
                  
                    </b-button>
                        </router-link>
                      <router-link
                        v-else
                        class="text-primary"
                        :to="`/user/update/${user.is_chat ? 1 : 0}/${user.answer_id}
                    `"
                      >
                    <b-button
                     :style="buttonCss"
                      type="filled"
                      class=" border-15 font-14 text-primary btn-padding white-space-sm  fw-bolder noHover"
                      variant="outline-primary"
                    >
                    
                        {{ $t("View") }}
                    
                    </b-button>
                      </router-link>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="mt-3 pt-2" v-if="this.$route.name == 'Document'">
          <Back />
        </div>
      </div>
    </div>
  </b-overlay>
</template>
<style >
.zoom {
  transition: transform 0.1s; /* Animation */
  /* width: 200px;
  height: 200px; */
}
.custom-image-class {
  box-shadow: 0px 0px 4px #888;
  padding: 5px;
}

.zoom:hover {
  transform: scale(2.5);
  z-index: 99999;
  /* (150% zoom - Note: if the zoom is too large, it will go outside of the viewport) */
}
.vs-con-input-label.is-label-placeholder {
  margin-top: 0px !important;
}
.preview .b-modal {
  /* position: absolte; */
  z-index: 80000 !important;
}

.home-card {
    box-shadow: 0px 3px 8px rgb(100,100,100);
    border-radius: 1.2rem !important;
}

.home-card .card-body {
  background-color: nono  !important;
  background: none !important;
 }

.bg-none {
 background-color: transparent !important;
}

</style>


<style lang="scss">

</style>
<script>
import { getLocalData,clearLocalData } from "@/utils/auth";

import $ from "jquery";
import { getFile } from "@/api/staff";
import ShowFilePreview from "@/components/show-file-preview.vue";
import {
  removeQaDocFile,
  replaceQaDocFile,
  rejectQaDocsFile,
  get,
} from "@/api/company-users";
import moment from "moment";
import Back from "@/views/users/component/Back";
import AuthImage from '@/components/auth/image';

export default {
  props: ["question_id",'appointment_id'],
  data() {
    return {
      style:[],
          buttonCss: {},
      textColor: {},
      routes:'',
      temp: [],
      previewLinks: [],
      temp: [],
      imageCount: [1, 2, 3, 4, 5],
      path: require("@/assets/images/portrait/small/avatar-s-9.jpg"),
      error: "",
      success: "",
      sec: 2,
      show: false,
      variant: "light",
      opacity: 0.85,
      blur: "2px",
      bgColor: {}
    };
  },

  computed: {
    appointments() {
      const question_id = this.question_id;
      const docs = this.$store.state.appointment.qa_document;
      if (question_id) return docs.filter((q) => q.question_id == question_id);
      return docs;
    },
    day() {
      return moment().format("dddd");
    },
    month() {
      return moment().format("MMMM");
    },
    day1() {
      return moment().format("D");
    },
    // getdate() {
    //   return moment().format("YYYY-MM-DD");
    // },
    current_date() {
      return moment().format("DD/MM/YYYY");
    },
  },
  components: {
    Back,
    AuthImage
  },
  created() {
    let id = this.$store.getters.currentUser.id;
    this.getAppointments(id);
    this.routes=this.$route.name;
      let details = getLocalData();
    if(details.company_id)
    this.getCustomStyle(details.company_id);
    // this.loadPreviewFiles();
    // this.getProfileCompleteness(id);
  },
  methods: {
         getCustomStyle(id) {
   let data = {
          company_id: id,
        }; 
      this.$store
        .dispatch("GetCustomStyle", data)
        .then((res) => {
          this.style=res.data.data;
          if (res.data.data.header_text)
            $(".header-text").html(res.data.data.header_text);
          if (res.data.data.footer_text)
            $(".footer-text").html(res.data.data.footer_text);

          $(".home-card").css({
            "background-color": res.data.data.form_background_color+ " !important",
          });

          if(res.data.data.form_background_color !== '#fff') {
            this.bgColor = {
              background: res.data.data.form_background_color + " !important",
            };
          }
          
          $(
            "span.vfc-span-day.vfc-disabled.vfc-cursor-not-allowed.vfc-hover, .vfc-day, .vfc-top-date.vfc-center span, span.e-input-group-icon.e-ddl-icon.e-search-icon"
          ).css({ color: res.data.data.form_text_color });
          $(".vfc-arrow-right, .vfc-arrow-left").css({
            "border-color": res.data.data.form_text_color,
          });

          $(".custome-text-color").css({
            color: res.data.data.form_text_color,
          });
          let css = {
            color: this.textColor.color,
            "border-bottom-color": this.textColor.color,
          };
          $(".e-control-wrapper").css(css);
          $("span.e-input-group-icon.e-ddl-icon.e-search-icon").css(
            this.textColor
          );
          this.textColor = {
            color: res.data.data.form_text_color + " !important",
          };

          $(".the-footer p, .the-footer a").css({
            color: res.data.data.form_text_color,
          });

          this.buttonCss = {
            "background-color":
              res.data.data.button_background_color + "!important",
            "border-color":
              res.data.data.button_background_color + "!important",
            color: res.data.data.button_text_color+ "!important",
          };
          if (res.data.data.background_images)
            $("#content-area").css({
              "background-image":
                "url('" + res.data.data.background_images.path + "')",
              "background-position": "inherit",
              "background-repeat": "no-repeat",
              "background-size": "cover",
              "background-attachment": "fixed",
            });
          else $("#content-area").css({ "background-image": "none" });
        })
        .catch((error) => {
          this.$log.error(
            "File : BookingForm.vue | Function : getCustomStyle() | Error :",
            error
          );
          // Error response
          this.error =
            this.$t(error.replace(/[\s\/]/g, "")) !==
            error.replace(/[\s\/]/g, "")
              ? this.$t(error.replace(/[\s\/]/g, ""))
              : error;
          this.$toasted.show(this.error, {
            className: "top-alert",
            position: "top-center",
            type: "error",
            duration: 2000,
          });
          return false;
        });
    },
    async showFile(filename, type, folder) {
      if (this.previewLinks[filename]) return;
      const response = await getFile(`${folder}`);
      let url = URL.createObjectURL(response.data);
    
      if (type == "pdf") url = `${url}#toolbar=0`;
      this.$set(this.previewLinks, filename, url);
    },

    async getFile(key, filename) {
      this.show = true;
      const ext = filename.split(".").pop();
      console.log(key);
      console.log(filename);
      const response = await getFile(`appointment-documents/${filename}`);
      const url = URL.createObjectURL(response.data);
      console.log(url);
      // const el = this.$refs.adownload;
      // const fileName = parseStringToURLFriendly(
      //   `${key} ${1} ${"name"} ${"filename"}`
      // );
      // el.download = `${fileName}.${ext}`;
      // el.href = url;
      // el.click();
      URL.revokeObjectURL(url);
      this.show = false;
    },
    catchMethod(error) {
      this.$log.error(
        "File : List.vue | Function : getAppointments() | Error :",
        error
      );
      this.show = false;
      // Error response
      this.error =
        this.$t(error.replace(/[\s\/]/g, "")) !== error.replace(/[\s\/]/g, "")
          ? this.$t(error.replace(/[\s\/]/g, ""))
          : error;
      this.$toasted.show(this.error, {
        className: "top-alert",
        position: "top-center",
        type: "error",
        duration: 2000,
      });
      return false;
    },
    getAppointments(id) {
      this.show = true;
      var data = {
        id: id,
        params: { question_type: "file",appointment_id:this.appointment_id },
      };
      let api = "GetUserDocuments";
      this.$store
        .dispatch(api, data)
        .then((res) => {
          this.show = false;
          this.temp = res.data.data;
          console.log(res.data.data);
          this.$store.commit("SET_APPOINTMENT_QA_DOCUMENT", res.data.data);
          let folder = '';
          res.data.data.forEach((el) => {
            folder = el.is_chat ? el.path : `appointment-documents/${el.answer}`; 
            this.showFile(el.answer, "image", folder);
          });
        })
        .catch((error) => {
          this.catchMethod(error);
        });
    },

    selectedImage(image) {
      this.preview = true;
      this.temp = image;
      this.$bvModal.hide("modal-1");
    },
    selectedImage1() {
      this.image = this.temp;
    },
    /**
     * image validation
     */
    selectedFile(event) {
      this.success = "";
      this.error = "";
      var filePath = event.target.files[0].name;
      var allowedExtensions = /(\.jpg|\.jpeg|\.png|\.gif)$/i;
      if (!allowedExtensions.exec(filePath)) {
        this.error = this.$t("FileUploadError");
        this.$toasted.show(this.error, {
          className: "top-alert",
          position: "top-center",
          type: "error",
          duration: 2000,
        });
        $("#profile_image").val("");
      } else {
        this.images = event.target.files[0];
        // this.file_name = this.images.name;
        // this.url = URL.createObjectURL(this.images);
        // this.crop.src = URL.createObjectURL(this.images);
      }
    },
  },
};
</script>